module.exports = __webpack_public_path__ + "img/SlothysLogo.b14799f7.png";